import React, { Component } from 'react';
import { Form, Input, Checkbox, Segment, Button, Modal } from 'semantic-ui-react';
import { observer } from 'mobx-react';
import MaterialSelector from '../materials/MaterialSelector';

export default observer(class extends Component {

  state = {
    isMaterialSelectorOpen: false,
    isFixedLengthStock: false
  }

  render() {
    if (!this.props.part) return null
    const {  
      name, 
      materialId,
      materialDescription, 
      materialUnits, 
      materialStockLength,
      materialSheetSizeX,
      materialSheetSizeY,
      materialUnitCost,
      qty, 
      cutLength, 
      cutWidth, 
      comment 
    } = this.props.part;
    const hasCutDimensions = materialUnits === 'metre' || materialUnits === 'length' || materialUnits === 'sheet';
    const costPer = {
      each: 'each',
      metre: 'per metre',
      sheet: 'per sheet'
    }
    return (
      <div>
        <MaterialSelector
          isOpen={this.state.isMaterialSelectorOpen}
          onClose={this.closeMaterialSelector}
          onSelectItem={this.applySelectedMaterial}
        />
        <Modal open={this.props.isOpen}>
          <Modal.Header>{this.props.isNew ? 'New Part' : 'Edit Part'}</Modal.Header>
          <Modal.Content scrolling>
            <Form as='div' onSubmit={this.handleSubmit}>
              <Form.Group>
                <Form.Input
                  width={5}
                  value={name} 
                  label='Part' 
                  onChange={this.handleChangeName}
                />
                <Form.Field width={11}>
                  <label>Material</label>
                  <Input 
                    action
                    value={materialDescription}
                    onChange={this.handleChangeMaterialDescription}>
                    <input/>
                    <Button primary onClick={this.openMaterialSelector}>Select Material</Button>
                  </Input>
                </Form.Field>
              </Form.Group>
              <Segment tertiary={materialId ? true : false}>
                <Form.Group>
                  <Form.Field width={3}>
                    <label>Units</label>
                    <select value={materialUnits} onChange={this.handleChangeMaterialUnits}>
                      <option value='each'>each</option>
                      <option value='metre'>per metre</option>
                      <option value='sheet'>stock sheet</option>
                    </select>
                  </Form.Field>
                  {materialUnits === 'metre' &&
                    <Form.Field width={4}>
                      <label>Fixed length stock?</label>
                      <Checkbox label='Yes' checked={this.state.isFixedLengthStock} onChange={this.handleChangeFixedLengthCheckbox} />
                    </Form.Field>
                  }
                  {materialUnits === 'metre' && this.state.isFixedLengthStock &&
                    <Form.Field width={4}>
                      <label>Length of stock</label>
                      <Input 
                        type='number'
                        step='0.001'
                        value={materialStockLength || ''}
                        onChange={this.handleChangeMaterialStockLength}
                        fluid
                        label='m' 
                        labelPosition='right' 
                        onFocus={this.selectAll}
                      />
                    </Form.Field>
                  }
                  {materialUnits === 'sheet' &&
                    <Form.Field width={7}>
                      <label>Sheet size</label>
                      <Form.Group inline widths='equal'>
                        <Input 
                          type='number'
                          step='0.001'
                          max='99'
                          placeholder='Length'
                          value={materialSheetSizeX}
                          onChange={this.handleChangeMaterialSheetSizeX}
                          fluid
                          label='m' 
                          labelPosition='right' 
                          onFocus={this.selectAll}
                        />
                        <Input 
                          type='number'
                          step='0.001'
                          max='99'
                          placeholder='Width'
                          value={materialSheetSizeY}
                          onChange={this.handleChangeMaterialSheetSizeY}
                          fluid
                          label='m' 
                          labelPosition='right' 
                          onFocus={this.selectAll}
                        />
                      </Form.Group>
                    </Form.Field>
                  }
                  <Form.Field width={5}>
                    <label>Cost</label>
                    <Input 
                      type='number'
                      step='0.01'
                      value={materialUnitCost}
                      onChange={this.handleChangeMaterialUnitCost}
                      fluid 
                      label={costPer[materialUnits]} 
                      labelPosition='right' 
                      icon='dollar'
                      iconPosition='left'
                      onFocus={this.selectAll}
                    />
                  </Form.Field>
                </Form.Group>
              </Segment>
              <Form.Group>
                <Form.Input
                  width={3}
                  type='number'
                  value={qty} 
                  label='Qty' 
                  onChange={this.handleChangeQty}
                  onFocus={this.selectAll}
                />
                {hasCutDimensions &&
                  <Form.Field width={7}>
                    <label>Cut at</label>
                    <Form.Group inline widths='equal'>
                      <Input 
                        placeholder='Length'
                        value={cutLength || ''}
                        onChange={this.handleChangeCutLength}
                        fluid type='number' 
                        label='mm' 
                        labelPosition='right' 
                        onFocus={this.selectAll}
                      />
                      {materialUnits === 'sheet' &&
                        <Input 
                          placeholder='Width'
                          value={cutWidth || ''}
                          onChange={this.handleChangeCutWidth}
                          fluid type='number' 
                          label='mm' 
                          labelPosition='right' 
                          onFocus={this.selectAll}
                        />
                      }
                    </Form.Group>
                  </Form.Field>
                }
              </Form.Group>
              <Form.Input placeholder='Optional' value={comment} label='Comment' onChange={this.handleChangeComment} />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button type='button' positive disabled={!this.props.part.isValid} onClick={this.props.onSave}>OK</Button>
            <Button type='button' color='orange' onClick={this.props.onCancel}>Cancel</Button> 
          </Modal.Actions>
        </Modal>
      </div>
    )
  }

  selectAll = event => event.target.select()

  openMaterialSelector = () => this.setState({ isMaterialSelectorOpen: true })

  closeMaterialSelector = () => this.setState({ isMaterialSelectorOpen: false })

  applySelectedMaterial = material => {
    const { part } = this.props
    part.setMaterialId(material.id)
    part.setMaterialDescription(material.description)
    part.setMaterialUnits(material.units)
    if (material.stockLength) {
      part.setMaterialStockLength(material.stockLength)
      this.setState({ isFixedLengthStock: true })
    }
    if (material.units === 'sheet') {
      part.setMaterialSheetSize(material.sheetSizeX, material.sheetSizeY)
    }
    part.setMaterialUnitCost(material.unitCost)
    this.closeMaterialSelector()
  }

  handleChangeFixedLengthCheckbox = event => {
    this.setState({
      isFixedLengthStock: !this.state.isFixedLengthStock
    }, () => {
      this.props.part.setMaterialStockLength(this.state.isFixedLengthStock ? 5.5 : null)
    })
  }

  handleChangeName = event => {
    this.props.part.setName(event.target.value)
  }

  handleChangeMaterialDescription = event => {
    this.props.part.setMaterialDescription(event.target.value)
  }
  
  handleChangeMaterialUnits = event => {
    const units = event.target.value
    this.props.part.setMaterialUnits(units)
    if (units === 'length') this.props.part.setMaterialStockLength(5.500)
    if (units === 'sheet') {
      this.props.part.setMaterialSheetSizeX(2.438)
      this.props.part.setMaterialSheetSizeY(1.219)
    }
  }
  
  handleChangeMaterialStockLength = event => {
    const parsedValue = parseFloat(event.target.value)
    if (!isNaN(parsedValue)) this.props.part.setMaterialStockLength(parsedValue)
  }
  
  handleChangeMaterialSheetSizeX = event => {
    const parsedValue = parseFloat(event.target.value)
    if (!isNaN(parsedValue)) this.props.part.setMaterialSheetSizeX(parsedValue)
  }
  
  handleChangeMaterialSheetSizeY = event => {
    const parsedValue = parseFloat(event.target.value)
    if (!isNaN(parsedValue)) this.props.part.setMaterialSheetSizeY(parsedValue)
  }
  
  handleChangeMaterialUnitCost = event => {
    const parsedValue = parseFloat(event.target.value)
    if (!isNaN(parsedValue)) this.props.part.setMaterialUnitCost(parsedValue)
  }

  handleChangeQty = event => {
    const parsedValue = parseInt(event.target.value, 10)
    if (!isNaN(parsedValue)) this.props.part.setQty(parsedValue)
  }
    
  handleChangeCutLength = event => {
    const parsedValue = parseFloat(event.target.value)
    if (!isNaN(parsedValue)) this.props.part.setCutLength(parsedValue)
  }
    
  handleChangeCutWidth = event => {
    const parsedValue = parseFloat(event.target.value)
    if (!isNaN(parsedValue)) this.props.part.setCutWidth(parsedValue)
  }

  handleChangeComment = event => {
    this.props.part.setComment(event.target.value)
  }
})


// WEBPACK FOOTER //
// ./src/components/jobs/PartForm.js